import Vue from "vue";
import Vuex from "vuex";
// import loginService from "../services/loginService";
import axios from "axios";
import papirusConfig from "../services/configService";

Vue.use(Vuex);

export default new Vuex.Store({
  state() {
    return {
      authParam: {
        axiosConfig: undefined,
        baseUrl: papirusConfig.currentConfig.AuthEndpoint
      },
      errorState: {
        message: ""
      },
      data_token: ""
    };
  },
  getters: {
    authUrl: (state) => state.authParam.baseUrl,
    defaultHeaders: (state) => state.$_defaultHeaders,
    errors: (state) => state.errorState
  },
  mutations: {
    SET_AUTH_URL(state, value) {
      state.authParam.baseUrl = value;
    },
    SET_ERROR_DATA(state, value) {
      state.errorState = value;
    },
    SET_DATA_TOKEN(state, value) {
      state.data_token = value;
    }
  },
  actions: {
    setAuthBaseUrl({ commit }, config) {
      config = config.endsWith("/") ? config : config + "/";
      commit("SET_AUTH_URL", config);
    },
    clear({ commit }) {
      commit("SET_ERROR_DATA", { message: "" });
      commit("SET_DATA_TOKEN", "");
    },
    async ForgotPasswordHandler({ commit, state, getters }, payload) {
      var base = getters.authUrl;
      base = base.endsWith("/") ? base : base + "/";
      let url = base + "Account/v1.0/ForgotPasswordAsync";
      try {
        let response = await axios.post(url, payload.data);
        var salida = response.data;
        if (salida.data && salida.success) {
          SetToken(commit, response, state);
        } else {
          throw "";
        }
      } catch (error) {
        GetErrors(error, state);
        // await dispatch("handleUnauthorizedError", error, {
        //   root: true
        // });
        throw "";
      }
    },
    async SetForgotPasswordHandler({ state, getters }, payload) {
      if (state.data_token == null || state.data_token == "") {
        await this.$router.push("SetForgotPassword");
      }

      const config = {
        headers: { Authorization: `Bearer ${state.data_token}` }
      };
      var base = getters.authUrl;
      base = base.endsWith("/") ? base : base + "/";
      let url = base + "Account/v1.0/SetForgotPasswordAsync";
      try {
        let response = await axios.post(url, payload.data, config);
        var salida = response.data;
        if (salida.data && salida.success) {
          state.data_token = response.data.token;
        } else {
          throw "";
        }
      } catch (error) {
        GetErrors(error, state);
        throw "";
        // await dispatch("handleUnauthorizedError", error, {
        //   root: true
        // });

        // throw "";
      }
    },
    async ChangePasswordHandler({ state, getters }, { payload, token }) {
      //var token = localStorage.getItem("tkn");
      state.data_token = token;
      // console.log("state.data_token", token);

      if (state.data_token == null || state.data_token == "") {
        await this.$router.push("ChangePassword");
      }

      const config = {
        headers: { Authorization: `Bearer ${state.data_token}` }
      };

      var base = getters.authUrl;
      base = base.endsWith("/") ? base : base + "/";
      let url = base + "AccountUsers/v1.0/ChangePassworAsync";
      try {
        let response = await axios.put(url, payload.data, config);
        var salida = response.data;
        if (salida.success) {
          return true;
        } else {
          throw "";
        }
      } catch (error) {
        GetErrors(error, state);
        throw "";
      }
    }
  }
});

function GetErrors(error, state) {
  var dataError = JSON.parse(JSON.stringify(error.response.data));
  var dataMessage = JSON.parse(JSON.stringify(dataError.errors[0]));
  state.errorState = dataMessage;
}

function SetToken(commit, response, state) {
  var data = JSON.parse(JSON.stringify(response.data));
  var token = `${JSON.stringify(data).split(":")[2].split('"')[1]}`;
  state.data_token = token;
  commit("SET_DATA_TOKEN", token);
}
